module.exports = __webpack_public_path__ + "img/depmap_svg_V92.8eac6628.svg";